import { useMemo } from "react";

import { isApplePlatform, multilineCommitLabel } from "@/lib/editing";
import { cx } from "@/lib/cx";

/**
 * The ⌘↵ (Ctrl ↵ off Apple hardware) a button also answers to, drawn on the button
 * itself so the shortcut is found where the click would go. Only for a button whose
 * form really commits on that chord. Hidden at phone width: no keyboard there, and the
 * wider button would push a tight bar (the Flows decision row) onto two lines.
 */
export function KeyHint({ className }: { className?: string }) {
  const label = useMemo(() => multilineCommitLabel(isApplePlatform()), []);
  return (
    <kbd className={cx("ml-1.5 font-sans text-[0.85em] font-normal opacity-70 max-[719px]:hidden", className)} aria-hidden="true">
      {label}
    </kbd>
  );
}
